import Vue from 'vue'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context('@/filters', true, /\.js$/)

requireComponent.keys().forEach(fileName => {
  if (fileName === './index.js') return
  const componentConfig = requireComponent(fileName)
  const componentName = camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  Vue.filter(componentName, componentConfig.default || componentConfig)
})
